import { useSelector } from "react-redux";

export const useAdminPermission = () => {
  const adminData = useSelector((state) => state.adminFunction.queue.adminData);

  return {
    accessStudentData: adminData?.permission?.accessStudentData || false,
    admitCandidate: adminData?.permission?.admitCandidate || false,
    deleteApplicant: adminData?.permission?.deleteApplicant || false,
    employStaff: adminData?.permission?.employStaff || false,
    financeControl: adminData?.permission?.financeControl || false,
    freeRegistration: adminData?.permission?.freeRegistration || false,
    fullControll: adminData?.permission?.fullControll || false,
    recommendCandidate: adminData?.permission?.recommendCandidate || false,
    studentReform: adminData?.permission?.studentReform || false,
    deleteStudentData: adminData?.permission?.deleteStudentData || false,
  };
};
